import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { Link } from "react-router-dom";

const WebLogo = "../../../../assets/images/web.png";
const AppLogo = "../../../../assets/images/app.png";
const BothLogo = "../../../../assets/images/webAndapp.png";

const ProjectCard = ({ item, logo, index }) => {
  const cardRef = useRef(null);
  const cardShadowAnimation = useRef(null);
  const iconAnimation = useRef(null);
  const logoAnimation = useRef(null);

  console.log(item, "item")

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    if (!cardRef.current) {
      return;
    }

    // Entrance animation with ScrollTrigger
    gsap.fromTo(cardRef.current,
      {
        y: 50,
        opacity: 0,
        scale: 0.9
      },
      {
        y: 0,
        opacity: 1,
        scale: 1,
        duration: 0.6,
        ease: "power3.out",
        delay: index * 0.1,
        scrollTrigger: {
          trigger: cardRef.current,
          start: "top 85%",
          toggleActions: "play none none reverse"
        }
      }
    );

    // Icon animation with theme color
    iconAnimation.current = gsap.fromTo(
      cardRef.current.querySelector(".iconsList"),
      {
        y: -50,
        opacity: 0,
        scale: 0.8
      },
      {
        y: 0,
        opacity: 1,
        scale: 1,
        delay: 0.3 + (index * 0.1),
        ease: "back.out(1.7)",
        duration: 0.6,
      }
    );

    // Logo animation
    const logoElement = cardRef.current.querySelector(".project-logo");
    if (logoElement) {
      logoAnimation.current = gsap.fromTo(logoElement,
        {
          y: 30,
          opacity: 0,
          scale: 0.9
        },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          delay: 0.5 + (index * 0.1),
          ease: "power2.out",
          duration: 0.5,
        }
      );
    }

    // Enhanced card shadow animation with theme color
    cardShadowAnimation.current = gsap.to(cardRef.current, {
      boxShadow: `0 20px 40px ${item.activeColor}30, 0 8px 20px ${item.activeColor}20, 0 0 0 1px ${item.activeColor}20`,
      y: -10,
      scale: 1.05,
      paused: true,
      duration: 0.4,
      ease: "power2.out",
    });

  }, [item.activeColor, index]);

  const onMouseEnterHandler = () => {
    if (cardShadowAnimation.current) {
      cardShadowAnimation.current.play();
    }

    // Animate icon on hover
    const iconElement = cardRef.current?.querySelector(".iconsList li");
    if (iconElement) {
      gsap.to(iconElement, {
        scale: 1.1,
        rotation: 5,
        duration: 0.3,
        ease: "power2.out"
      });
    }

    // Animate logo on hover
    const logoElement = cardRef.current?.querySelector(".project-logo");
    if (logoElement) {
      gsap.to(logoElement, {
        scale: 1.05,
        y: -5,
        duration: 0.3,
        ease: "power2.out"
      });
    }
  };

  const onMouseLeaveHandler = () => {
    if (cardShadowAnimation.current) {
      cardShadowAnimation.current.reverse();
    }

    // Reset icon animation
    const iconElement = cardRef.current?.querySelector(".iconsList li");
    if (iconElement) {
      gsap.to(iconElement, {
        scale: 1,
        rotation: 0,
        duration: 0.3,
        ease: "power2.out"
      });
    }

    // Reset logo animation
    const logoElement = cardRef.current?.querySelector(".project-logo");
    if (logoElement) {
      gsap.to(logoElement, {
        scale: 1,
        y: 0,
        duration: 0.3,
        ease: "power2.out"
      });
    }
  };

  return (
    <Link
      to={`/projects/${item._id}`}
      onMouseEnter={onMouseEnterHandler}
      onMouseLeave={onMouseLeaveHandler}
      ref={cardRef}
      key={index}
      className="project-card block overflow-hidden transition-all duration-50 ease-in-out p-6 rounded-xl shadow-md"
      style={{
        backgroundColor: '#f8fafc',
        // boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.1)'
      }}
    >
      <div className="flex flex-col justify-center items-center h-full py-10 relative">
        {/* Icon Container with Theme Color */}
        <div
          className="w-10 h-10 p-2 rounded-full transition-all bg-gray-100 duration-300 absolute left-0 top-0 flex items-center justify-center"
          style={{
            backgroundColor: `${item.activeColor}15`,
            boxShadow: `0 4px 12px ${item.activeColor}25`
          }}
        >
          <img
            src={item.type === "web" ? WebLogo : item.type === "app" ? AppLogo : BothLogo}
            className="w-5 h-5 object-contain"
            alt="Project Icon"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
        </div>

        {/* Project Logo */}
        {logo && (
          <img
            src={logo}
            className="project-logo w-40 h-20 mb-4 object-contain transition-all duration-300"
            alt="Project Logo"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        )}

        {/* Project Title */}
        {/* <h3 
          className="text-lg font-semibold text-gray-800 text-center mb-2 transition-colors duration-300"
          style={{ 
            color: item.activeColor 
          }}
        >
          {item.name || 'Project Name'}
        </h3> */}

        {/* Theme Color Accent */}
        <div
          className="w-12 h-1 rounded-full transition-all duration-300"
          style={{ backgroundColor: item.activeColor }}
        />
      </div>
    </Link>
  );
};

export default ProjectCard;
